import React, { useState, useEffect } from 'react'
import { Modal, StyledSelect } from '@peracto/peracto-ui'
import { GET_LIST, useClient } from '@peracto/client'
import { ModalContent } from '../styled'
import AsyncSelect from 'react-select/async'
import debounce from 'debounce-promise'

const emailRegex = /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/
const CUSTOMER_TYPES = [
    { label: 'Existing Customer', value: 'existing' },
    { label: 'Guest', value: 'guest' },
]

const CustomerModal = ({ customerModal, setCustomerModal, onUpdateBasket }) => {
    const [customerType, setCustomerType] = useState('')
    const [emailAddress, setEmailAddress] = useState('')
    const [selectedCustomer, setSelectedCustomer] = useState()
    const { client } = useClient()

    useEffect(() => {
        setCustomerType('')
    }, [])

    const fetchCustomers = async input => {
        if (!customerModal) {
            return
        }
        try {
            const { data } = await client(GET_LIST, 'users', {
                filter: {
                    email: input,
                },
            })

            const values = data.map(user => ({
                label: `${user.firstName} ${user.lastName} <${user.email}>`,
                value: user['@id'],
            }))

            return values
        } catch (e) {
            console.error(e)
        }
    }

    const debouncedFetchCustomers = debounce(fetchCustomers, 200)

    useEffect(() => {
        if (!!customerModal === false) {
            setCustomerType(null)
        }
    }, [customerModal])

    useEffect(() => {
        return () => {
            setCustomerType(null)
        }
    }, [])

    return (
        <Modal
            className="modal-lg"
            isVisible={!!customerModal}
            title={`Select Customer`}
            close={() => setCustomerModal(false)}
            buttons={[
                {
                    type: 'btn-outline-secondary',
                    text: 'Cancel',
                    action: () => {
                        setCustomerModal(false)
                    },
                },
                {
                    type: 'btn-success',
                    text: 'Save',
                    disabled:
                        !!customerType === false ||
                        (customerType === 'guest' && !emailAddress.match(emailRegex)),
                    action: async () => {
                        const data =
                            customerType === 'existing'
                                ? { user: selectedCustomer }
                                : { user: null, email: emailAddress }

                        await onUpdateBasket(data)
                        setCustomerModal(false)
                    },
                },
            ]}
        >
            <ModalContent className="overflow-visible">
                <div className="row !w-full !text-left !m-0">
                    <div className="col-12">
                        <label>Customer Type</label>
                        <StyledSelect
                            options={CUSTOMER_TYPES}
                            onChange={e => setCustomerType(e.value)}
                            value={CUSTOMER_TYPES.find(type => type.value === customerType) || ''}
                        />
                    </div>

                    {!customerType && (
                        <div className="col-12">
                            <p className="!text-center !py-12">Please select a customer type</p>
                        </div>
                    )}

                    {customerType === 'existing' && (
                        <div className="col-12 !py-4">
                            <label>Please select a customer</label>
                            <AsyncSelect
                                className="!w-full"
                                loadOptions={input => debouncedFetchCustomers(input)}
                                isSearchable={true}
                                defaultOptions={true}
                                onChange={option => setSelectedCustomer(option.value)}
                                placeholder="Select a customer..."
                                classNamePrefix="peracto-select"
                                noOptionsMessage={({ inputValue }) => {
                                    if (inputValue.length > 0) {
                                        return `No email addresses found by '${inputValue}'.`
                                    } else {
                                        return 'Enter text to begin searching.'
                                    }
                                }}
                            />
                        </div>
                    )}

                    {customerType === 'guest' && (
                        <div className="col-12 !py-4">
                            <label>Please enter an email address</label>
                            <input
                                type="email"
                                className="form-control"
                                onChange={e => {
                                    setEmailAddress(e.target.value)
                                }}
                            />
                        </div>
                    )}
                </div>
            </ModalContent>
        </Modal>
    )
}

export default CustomerModal
